import StoreIcon from '@mui/icons-material/Store';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import FeedbackIcon from '@mui/icons-material/Feedback';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import PeopleIcon from '@mui/icons-material/People';
import CategoryIcon from '@mui/icons-material/Category';
import PublicIcon from '@mui/icons-material/Public';
import MapIcon from '@mui/icons-material/Map';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import { Admin, Resource } from 'react-admin';

import { authProvider } from './authProvider';
import { dataProvider } from './dataProvider';
import { AdminLayout } from './layout/AdminLayout';
import { LoginPage } from './layout/LoginPage';
import { BusinessCreate } from './resources/businesses/BusinessCreate';
import { BusinessEdit } from './resources/businesses/BusinessEdit';
import { BusinessList } from './resources/businesses/BusinessList';
import { Dashboard } from './resources/dashboard/Dashboard';
import { FeedbackList } from './resources/feedback/FeedbackList';
import { LeadList } from './resources/leads/LeadList';
import { TemplateCreate, TemplateEdit } from './resources/templates/TemplateEdit';
import { TemplateList } from './resources/templates/TemplateList';
import { UserCreate } from './resources/users/UserCreate';
import { UserEdit } from './resources/users/UserEdit';
import { UserList } from './resources/users/UserList';
import { CategoryCreate, CategoryEdit } from './resources/categories/CategoryEdit';
import { CategoryList } from './resources/categories/CategoryList';
import { CountryCreate, CountryEdit } from './resources/countries/CountryEdit';
import { CountryList } from './resources/countries/CountryList';
import { StateCreate, StateEdit } from './resources/states/StateEdit';
import { StateList } from './resources/states/StateList';
import { CityCreate, CityEdit } from './resources/cities/CityEdit';
import { CityList } from './resources/cities/CityList';
import { theme } from './theme';

export function App() {
  return (
    <Admin
      authProvider={authProvider}
      dataProvider={dataProvider}
      dashboard={Dashboard}
      layout={AdminLayout}
      loginPage={LoginPage}
      theme={theme}
      title="QRBusiness India Admin"
      requireAuth
    >
      <Resource
        name="businesses"
        list={BusinessList}
        edit={BusinessEdit}
        create={BusinessCreate}
        icon={StoreIcon}
        options={{ label: 'Businesses' }}
      />
      <Resource
        name="templates"
        list={TemplateList}
        edit={TemplateEdit}
        create={TemplateCreate}
        icon={ViewQuiltIcon}
        options={{ label: 'Templates' }}
      />
      <Resource
        name="categories"
        list={CategoryList}
        edit={CategoryEdit}
        create={CategoryCreate}
        icon={CategoryIcon}
        options={{ label: 'Categories' }}
      />
      <Resource
        name="countries"
        list={CountryList}
        edit={CountryEdit}
        create={CountryCreate}
        icon={PublicIcon}
        options={{ label: 'Countries' }}
      />
      <Resource
        name="states"
        list={StateList}
        edit={StateEdit}
        create={StateCreate}
        icon={MapIcon}
        options={{ label: 'States' }}
      />
      <Resource
        name="cities"
        list={CityList}
        edit={CityEdit}
        create={CityCreate}
        icon={LocationCityIcon}
        options={{ label: 'Cities' }}
      />
      <Resource
        name="users"
        list={UserList}
        edit={UserEdit}
        create={UserCreate}
        icon={PeopleIcon}
        options={{ label: 'Users' }}
      />
      <Resource
        name="leads"
        list={LeadList}
        icon={ContactMailIcon}
        options={{ label: 'Leads' }}
      />
      <Resource
        name="feedback"
        list={FeedbackList}
        icon={FeedbackIcon}
        options={{ label: 'Feedback' }}
      />
    </Admin>
  );
}
